<template>
	<el-dialog :visible.sync="visible" :title="$t('nat.text.editSnatRule')" :close-on-click-modal="false"
		:before-close="handleClose" class="edit-snat-rule-dialog">
		<el-form ref="form" label-width="130px" :rules="rules" :model="form" v-loading="eipsLoading">
			<!-- NAT网关 -->
			<el-form-item :label="$t('nat.text.nat') | withColon">
				<span>{{ natInfo.name | maybeEmpty }}</span>
			</el-form-item>
			<!-- SNAT规则粒度 -->
			<el-form-item :label="$t('nat.text.snatRuleGranularity') | withColon">
				<span>{{ SnatRuleGranularityMapConstant[rowInfo.granularity] }}</span>
			</el-form-item>
			<!--所属子网-->
			<el-form-item :label="$t('privateNetInstance.subnetBelongTo') | withColon" required
				v-if="rowInfo.granularity === 'subnet'">
				<span>{{ rowInfo.subnetName }}({{ rowInfo.subnetId }})</span>
			</el-form-item>
			<!--云物理服务器-->
			<el-form-item :label="$t('nat.text.server') | withColon" required v-if="rowInfo.granularity === 'server'">
				<span>{{ rowInfo.privateIp }}({{ rowInfo.instanceId }})</span>
			</el-form-item>
			<!--自定义网段-->
			<el-form-item :label="$t('nat.text.customCidr') | withColon" required v-if="rowInfo.granularity === 'custom'"
				key="customCidr" prop="customCidr">
				<span>{{ rowInfo.customCidr }}</span>
			</el-form-item>
			<!--弹性公网ip-->
			<el-form-item :label="$t('eip.text.eip') | withColon" required>
				<el-select multiple style="width: 50%;" v-model="form.eipIds" :no-data-text="$t('nat.placeholder.notEip')"
					:placeholder="$t('nat.placeholder.eip')" @visible-change="value => handleEipVisibleChange(value)"
					@change="value => changeEip(value)">
					<el-option v-for="item in eips" :key="item.eipId" :label="item.eip" :value="item.eipId">
					</el-option>
				</el-select>
			</el-form-item>
			<!--描述-->
			<el-form-item :label="$t('create.text.desc') | withColon" prop="desc" :show-message="false" ref="desc">
				<el-input type="textarea" :rows="4" style="width: 50%;" v-model="form.desc"></el-input>
				<p class="el-form-item-name-help" :class="{ 'el-form-item-help-error': this.formTag.desc == 'error' }">
					{{ $t('create.help.desc') }}</p>
			</el-form-item>
		</el-form>
		<div slot="footer">
			<el-button @click="cancelBind">
				{{ $t('privateNetInstance.cancel') }}
			</el-button>
			<el-button @click="sureBind" type="primary" :disabled="isConfirmDisabled" :loading="sureBtnLoading">
				{{ $t('privateNetInstance.bindSure') }}
			</el-button>
		</div>
	</el-dialog>
</template>

<script>
import {
	SnatRuleGranularityConstant,
	NatRuleConstant,
	AliasIpRuleConstant,
	SnatRuleGranularityMapConstant
} from '@/common/Constants';
import { uniqueArrayLegacy } from '@/common/tool';
import { getNatEipsApi, modifySNatRulesApi } from '@/api/nat/detail/actions';
import _ from 'lodash';
export default {
	name: 'EditSnatRule',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		natInfo: {
			type: Object,
			default: {}
		},
		rowInfo: {
			type: Object,
			default: {}
		}
	},
	data() {
		this.NatRuleConstant = NatRuleConstant;
		this.AliasIpRuleConstant = AliasIpRuleConstant;
		this.SnatRuleGranularityMapConstant = SnatRuleGranularityMapConstant;
		const validateLength = (rule, value, callback) => {
			if (this.form.desc.length > 256) {
				callback(new Error());
			} else {
				callback();
			}
		};
		return {
            eipsLoading: false,
            sureBtnLoading: false,
			form: {
				// eipIds: this.rowInfo.eipIds,
				eipIds: [],
				desc: this.rowInfo.description,
			},
			formTag: {
				desc: 0,
			},
			rules: {
				desc: [
					{ type: 'string', validator: validateLength, trigger: 'blur' }
				],
			},
			SnatRuleGranularityConstant: SnatRuleGranularityConstant,
			subnets: [],
			servers: [],
			eips: [],
		};
	},
	computed: {
		// 确定按钮是否置灰
		isConfirmDisabled: function () {
			return !this.form.eipIds.length;
		},
	},
	watch: {
		rowInfo(val) {
			console.log(val);
		},
	},
	created() {
		this.getEipList();
	},
	methods: {
		handleClose() {
            this.sureBtnLoading = false;
            this.eipsLoading = false;
			this.$emit('update:visible', false);
		},
		cancelBind() {
			this.handleClose();
		},
		sureBind() {
            this.sureBtnLoading = true;
			const params = {
				region: this.natInfo.region,
				clientToken: Normal.getClientToken(),
				natGatewayId: this.natInfo.natGatewayId,
				snatRuleId: this.rowInfo.snatRuleId,
				eipIds: this.form.eipIds,
				description: this.form.desc,
			};
			modifySNatRulesApi(params).then((res) => {
				this.$message.success(this.$t('privateNetInstance.operateSuccess'));
                this.handleClose();
                this.$emit('refresh');
			})
				.catch(async (err) => {
                    this.sureBtnLoading = false;
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				})
				.finally(() => {
					// this.handleClose();
					// this.$emit('refresh');
				});
		},


		handleEipVisibleChange(visible) {
			if (!visible) {
				return
			}
			this.getEipList();
		},

		getEipList() {
            this.eipsLoading = true;
			const params = {
				region: this.natInfo.region,
				natGatewayId: this.natInfo.natGatewayId,
				service: NatRuleConstant.SNAT
			};
			getNatEipsApi(params).then((res) => {
				if (res.errno === 10000 && res.data) {
                    this.form.eipIds = this.rowInfo.eipIds;
					this.eips = res.data.cnatEIPList.map(item => {
						return item
					});

                    /**
                     * 问题：停服的eip此接口不返回，通过 findNatGateway 返回的 全量 eipList
                     * 解决：通过 筛选停服的eip：elasticIpId 在全量列表筛选出停服的显示在下拉列表
                     * 最后和此接口查询的合并
                     * 
                     * 使用 groupBy 将eipList 转为 elasticIpId 为 key 的对象
                     */

                    const infoEipObj = _.groupBy(this.natInfo?.eipList, 'elasticIpId');
                    // console.log('infoEipObj', infoEipObj);
                    // 循环已选的数据，从infoEipObj 筛选出已选的全部 放入 selectedEip
                    const selectedEip = [];
                    for (const key in infoEipObj) {
                        this.form.eipIds.map(item => {
                            if (item === key) {
                                selectedEip.push(infoEipObj[key][0]);
                            }
                        })
                    }

                    // 转换格式
                    const allSelectedEip = selectedEip.map(item => {
                        return {
                            eip: item.elasticIp,
                            eipId: item.elasticIpId,
                        }
                    });
                    // console.log('allSelectedEip', allSelectedEip);
                    this.eips = uniqueArrayLegacy([...this.eips, ...allSelectedEip]);
				}
			}).finally(() => {
                this.eipsLoading = false;
			});
		},

		changeEip(value) {

		}
	},
};
</script>

<style lang="scss">
.edit-snat-rule-dialog {
    .el-form-item .el-form-item-help {
        padding-bottom: 0 !important;
    }
    .el-form-item__error {
        padding-bottom: 0 !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/nat/EditSnatRule.vue